module.exports = function (gsap, ScrollTrigger) {
    const counters = document.querySelectorAll(".counter");

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    counters.forEach(element => {
        const counter = { var: 0 };

        gsap.to(counter, 1, {
            var: element.dataset.target,
            scrollTrigger: {
                trigger: element,
            },
            onUpdate: function() {
                element.innerHTML = numberWithCommas(Math.ceil(counter.var));
            },
        });
    })
}